module.exports = __webpack_public_path__ + "static/media/tick.383334c7.svg";